export default __webpack_public_path__ + "static/media/pills@3x.ee1da3ce.png";